document.querySelectorAll('[data-multi-variant]').forEach((root) => {
  const addBtn = root.querySelector('[data-add]');
  const feedback = root.querySelector('[data-feedback]');

  addBtn.addEventListener('click', async () => {
    const items = [...root.querySelectorAll('.multi-variant__input:checked')]
      .map((input) => ({
        id: Number(input.dataset.variantId),
        quantity: 1,
      }));

    if (!items.length) {
      feedback.hidden = false;
      feedback.textContent = 'Sélectionne au moins une couleur.';
      return;
    }

    addBtn.disabled = true;
    feedback.hidden = false;
    feedback.textContent = 'Ajout en cours…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) throw new Error(await res.text());

      feedback.textContent = `${items.length} article(s) ajouté(s) au panier.`;
      // Notifie le thème pour rafraîchir le drawer panier
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    } catch (e) {
      feedback.textContent = "Erreur lors de l'ajout au panier.";
      console.error(e);
    } finally {
      addBtn.disabled = false;
    }
  });
});